import styled from "styled-components";

export const DashboardWrapper = styled.div`
  padding: clamp(14px, 1.042vw, 20px) clamp(75px, 4.688vw, 90px)
    clamp(24px, 1.563vw, 30px);
  max-height: calc(100vh - 98px);
  max-width: 1720px;
  margin: 0 auto;
  overflow: auto;
  /* max-height: calc(100vh - 81px); */
  img {
    width: 100%;
    max-width: 100%;
  }
`;
export const OverView = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: clamp(20px, 2.083vw, 40px);

  @media (max-width: 1023px) {
    grid-template-columns: 1fr 1fr;
  }
`;
export const Grid = styled.div`
  background: rgba(231, 238, 243, 0.5);
  border: 1px solid rgba(0, 85, 134, 0.5);
  backdrop-filter: blur(10px);
  border-radius: clamp(4.5px, 0.313vw, 6px);
  /* min-height: 128px; */
  padding: 7px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .heading-div {
    cursor: pointer;
  }
  .stats {
    h5 {
      font-size: clamp(16px, 1.146vw, 22px);
      /* line-height: 29px; */
      font-family: "latobold";
      display: flex;
      gap: 10px;
      align-items: center;
      svg {
        width: clamp(12px, 0.833vw, 16px);
        height: clamp(12px, 0.833vw, 16px);
      }
      &.green {
        color: #50a71e;
      }
      &.red {
        color: #de3c3c;
        svg {
          transform: rotate(180deg);
        }
      }
    }
  }
  > div {
    .heading {
      /* margin-bottom: clamp(4px, 0.313vw, 6px); */
      font-size: 12px;
      /* line-height: 24px; */
      letter-spacing: 0.004em;
      color: #000000;
      font-family: "latosemibold";
    }
    .order-number {
      font-size: 13px;
      /* line-height: 29px; */
      letter-spacing: 0.004em;
      color: #0a5587;
      display: flex;
      gap: clamp(8px, 0.625vw, 12px);
      font-family: "latobold";
      align-items: baseline;
      span {
        font-size: clamp(10.5px, 0.729vw, 14px);
        color: #00000099;
        font-family: "latoregular";
      }
    }
  }
  /* @media (max-width: 1670px) {
    padding: 23px 15px;
    > div {
      .header {
        margin-bottom: 15px;
        font-size: 18px;
      }
      .order-number {
        font-size: 20px;
        line-height: normal;
        span {
          font-size: 14px;
          line-height: 22px;
        }
      }
    }
    .stats {
      h5 {
        font-size: 20px;
        line-height: 22px;
        gap: 6px;
      }
    }
  } */
`;

export const DashboardChartOuterWrapperChart = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    margin-bottom: 15px;
    gap: 15px;
  > div {
    width: 100%;
  }
  .flex-wrapper {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .active {
    background: black;
    color: white;
  }
  @media (max-width: 1356px) {
    display: flex;
    flex-direction: column;
    > div {
      max-width: 100%;
    }
  }
`;

export const DashboardChartOuterWrapper = styled.div`
  gap: clamp(12px, 0.781vw, 15px);
  display: flex;
  > div {
    max-width: calc(50% - 7.5px);
    width: 100%;
  }
  .flex-wrapper {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .active {
    background: black;
    color: white;
  }
  @media (max-width: 1356px) {
    flex-direction: column;
    > div {
      max-width: 100%;
    }
  }
`;

export const ChartFilterWrapper = styled.div`
    display: flex;
    gap: 10px;
    margin-bottom: 5px;    
    margin-top: 5px;
    justify-content: end;
`

export const OverviewContainer = styled.div`
  background: #ffffff;
  border-radius: clamp(11px, 0.781vw, 15px);
  padding: 10px 20px;

  > h6 {
    font-size: clamp(12px, 0.833vw, 16px);
    color: rgb(0, 85, 134);
    font-family: "latobold";
    margin-bottom: 8px;
  }
`;
export const ChartWrapper = styled.div`
  padding: 0 20px 10px;
  background: #ffffff;
  border: 1.5px solid rgba(211, 211, 211, 0.5);
  border-radius: 15px;
  min-height: 380px;
  .lineBarChartWrapper, .pieChartWrapper{
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 10px 0px;
  }
  .chart-wrapper {
    margin-top: 10px;
    height: 240px;
    display: flex;
    justify-content: center;
  }
  .pie-chart-wrapper {
    position: relative;
    display: flex;
    justify-content: center;
    padding: 25px;
    height: 240px;
    flex-direction: column;
    align-items: center;
    margin-top: 30px;
  }
  .label-container {
      display: flex;
      justify-content: center;
      margin-top: 16px;
      flex-wrap: wrap;
  }

  .label-container p {
      margin: 2px 5px;
      font-size: 13px;
      white-space: nowrap;
  }
  .label-point {
      width: 11px;
      height: 11px;
      border-radius: 50%;
      display: inline-block;
      margin-right: 5px;
  }
  .table-container{
    font-size: 12px;
    display: grid;
    align-items: start;
    // margin-top: -35px;
  }
  
  .table-row-header{
    display: grid;
    grid-template-columns: 5.5fr 2fr;
    text-align: center;
    border: 1px solid #dcedf7;
    border-bottom: none;
    font-family: 'latobold';
    background: #dcedf7;
    padding: 5px;
  }

  .table-row {
    display: grid;
    grid-template-columns: 4fr 1fr 2fr;
  }

  .table-cell {
      border-bottom: 1px solid #dee2e6;
      padding: 4px;
      text-align: center;
  }

  .table-cell-first {
      border-left: 1px solid #dee2e6;
      text-align: start;
  }

  .table-cell-third {
      border-right: 1px solid #dee2e6;
      white-space: nowrap;
  }

  .table-row-last {
      border-bottom: none;
  }
  
  .table-row:nth-child(odd) {
      background-color: #ffffff;
  }

  .table-row:nth-child(even) {
      background-color: #f9f9f9;
  }

  .volume-header{
    padding: 0;
    text-align: end;
    padding-right: 5px;
  }
`;

// buyback details related styles
export const BuyBackWrapper = styled.div`
  max-width: 600px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100%;
`

export const Container = styled.div`
  .buybackHeader{
    color: #005586;
    font-size: 14px;
    font-family: 'latobold';
    border: 1px solid #c0dff1;
    border-bottom: none;
    border-top: 1px solid #ebf8ff;
    padding: 5px;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 20px 0;
  border-bottom: 1px solid #ddd;
  gap: 15px;
`;

export const HeaderItem = styled.div`
  text-align: center;
  flex: 1;
  background: #E3F5FF;
  padding: 15px 0px 10px 20px;
  text-align: left;
  border-radius: 15px;
`;

export const Label = styled.div`
  font-size: 13px;
  color: #666;
  font-family: 'latomedium';
`;

export const Value = styled.div`
  font-size: 20px;
  font-family: 'latobold';
  color: #333;
`;

export const BuybackTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #d8d8d8;
`;

export const TableHeader = styled.th`
  background-color: #f7f7f7;
  padding: 5px;
  text-align: left;
  background: #DCEDF7;
  font-size: 14px;
  font-family: 'latobold';
`;

export const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f7f7f7;
  }
`;

export const TableCell = styled.td`
  padding: 5px;
  border-bottom: 1px solid #ddd;
  font-size: 14px;
  height: 25px;
`;

export const Footer = styled.div`
  margin-top: 20px;
  font-size: 14px;
  .header{
    color: #005586;
    font-family: 'latobold';
  }
  .content{
    font-family: 'latomedium';
  }
`;
